/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./node_modules/isinview/dist/index.es.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var defaultOptions = {
    once: false,
    threshold: 0,
};
var buildOptions = function (options) {
    return __assign(__assign({}, defaultOptions), options);
};
var observe = function (target, observer) {
    var targets = target instanceof Element ? [target] : target;
    for (var i = 0; i < targets.length; i++) {
        observer.observe(targets[i]);
    }
};
var createObserver = function (callback, options, condition) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var target = entry.target;
            if (entry.rootBounds !== null && condition(entry)) {
                callback(target, {
                    isAboveView: entry.boundingClientRect.bottom < entry.rootBounds.height / 2 && entry.boundingClientRect.top < 0,
                    isInView: entry.isIntersecting,
                    isBelowView: entry.boundingClientRect.top > entry.rootBounds.height / 2 && entry.boundingClientRect.bottom > entry.rootBounds.height,
                });
                if (options.once) {
                    observer.unobserve(target);
                }
            }
        });
    }, {
        threshold: options.threshold,
    });
    return observer;
};
function isSupported() {
    return 'IntersectionObserver' in window;
}
var isInView = function (target, callback, options) {
    if (options === void 0) { options = {}; }
    var completeOptions = buildOptions(options);
    var observer = createObserver(callback, completeOptions, function (entry) { return entry.isIntersecting; });
    observe(target, observer);
};
var isOutOfView = function (target, callback, options) {
    if (options === void 0) { options = {}; }
    var completeOptions = buildOptions(options);
    var observer = createObserver(callback, completeOptions, function (entry) { return !entry.isIntersecting; });
    observe(target, observer);
};


//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/async-wait-until/dist/index.esm.js
class e extends Error{constructor(t){super(null!=t?`Timed out after waiting for ${t} ms`:"Timed out"),Object.setPrototypeOf(this,e.prototype)}}const t=(e,t)=>new Promise(((o,n)=>{try{e.schedule(o,t)}catch(e){n(e)}})),o={schedule:(e,t)=>{let o;const n=e=>{null!=e&&clearTimeout(e),o=void 0};return o=setTimeout((()=>{n(o),e()}),t),{cancel:()=>n(o)}}},n=50,r=5e3,c=Number.POSITIVE_INFINITY,l=(n,r,l)=>{var s,u;const i=null!==(s="number"==typeof r?r:null==r?void 0:r.timeout)&&void 0!==s?s:5e3,a=null!==(u="number"==typeof r?l:null==r?void 0:r.intervalBetweenAttempts)&&void 0!==u?u:50;let m=!1;const d=()=>new Promise(((e,r)=>{const c=()=>{m||new Promise(((e,t)=>{try{e(n())}catch(e){t(e)}})).then((n=>{n?e(n):t(o,a).then(c).catch(r)})).catch(r)};c()})),h=i!==c?()=>t(o,i).then((()=>{throw m=!0,new e(i)})):void 0;return null!=h?Promise.race([d(),h()]):d()};//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/js/packages/section-slideshow.js



if (!customElements.get('slideshow-component')) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();

      this.slideshow = this.querySelector('.splide');
      this.slideshowList = this.slideshow.querySelector('.splide__list');

      this.initSlideshow();     
    }

    initSlideshow() {
      this.options = JSON.parse(this.slideshow.dataset.options);

      // If video slides use the slide method instead of a looping carosel
      const videoSlides = this.slideshow.querySelectorAll('.splide__slide[data-type="video"]');
      if (videoSlides.length > 0) {
        this.options.type = 'slide';
        this.options.rewind = true;
      }

      this.Splide = new theme.Splide(this.slideshow, this.options);

      this.Splide.on('move', (index, prev, dest) => {
        let indexId = index + 1;
        if (indexId < 10) {
          indexId = `0${indexId}`;
        }

        const destSlide = this.slideshow.querySelector(
          `#${this.Splide.root.id}-slide${indexId}`
        );
        const destSlideImage = destSlide.querySelector('.slide__image');
        this.slideshowList.style.height = `${destSlideImage.offsetHeight}px`;

        if (destSlide.getAttribute('data-type') === 'video') {
          this.initSlideVideo(destSlide);
        }
      });

      this.Splide.on('mounted', () => {
        this.onResize();

        const activeSlide = this.slideshow.querySelector(
          '.splide__slide.is-active'
        );
        if (activeSlide.getAttribute('data-type') === 'video') {
          this.initSlideVideo(activeSlide);
        }
      });

      this.Splide.mount();

      this.bindEditorEvents();
    }

    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        const activeSlideImage = this.slideshow.querySelector(
          '.splide__slide.is-active .slide__image'
        );
        if ( this.Splide.state.is( theme.Splide.STATES.IDLE ) ) {
          this.slideshowList.style.height = `${activeSlideImage.offsetHeight}px`;
        }
      });

      this.slideshowResizeObserver.observe(this.slideshow);
    }

    loadYouTubeAPI() {
      if (window.YT !== undefined) {
        theme.youTubeApiStatus = 'ready';
      }
      if (
        theme.youTubeApiStatus !== 'loaded' ||
        theme.youTubeApiStatus !== 'ready'
      ) {
        const script = document.createElement('script');
        script.id = `youtube-iframe-api`;
        script.src = `https://www.youtube.com/iframe_api`;
        script.async = true;
        script.onload = async () => {
          await l(() => window.YT.Player !== undefined, {
            timeout: 10000,
          });
          theme.youTubeApiStatus = 'loaded';
        };
        document.body.append(script);
      }
    }

    async initSlideVideo(slide) {

      try {
        await l(() => theme.userInteraction === true, {
          timeout: 4000,
        });
      } catch (error) {
        if (error instanceof e) {
          theme.userInteraction = true;
        }
      }
      console.log('after wait');

      if (slide.dataset.videoLoaded === 'true') return;

      if (theme.youTubeApiStatus !== 'loaded') {
        this.loadYouTubeAPI();
        await l(() => theme.youTubeApiStatus === 'loaded', { timeout: 10000 });
      }
      
      const videoSlideHTML = `<div class="slide__video absolute inset-0 z-20"></div>`;
      const slideContain = slide.querySelector('.slide__contain');
      slideContain.insertAdjacentHTML('beforeend', videoSlideHTML);

      const videoSlide = slide.querySelector('.slide__video');
      const videoId = slide.dataset.videoId;

      const videoSlideBackground = new theme.Vidim(videoSlide, {
        type: 'YouTube',
        src: videoId
      });

      videoSlideBackground.once('ready', function() {
        this.container.style.opacity = 0;
        this.play();

        // Play pause when in view
        const options = {
          threshold: 0.001,
        }

        isInView(slide, (target) => {
          videoSlideBackground.play();
        }, options);

        isOutOfView(
          slide,
          (target) => {
            videoSlideBackground.pause();
          },
          options
        );
      });

      videoSlideBackground.once('play', function(){
        const container = this.container;
        const showDelay = 200;
        window.setTimeout(function () {
          container.style.opacity = 1;
        }, showDelay);
      });

      slide.dataset.videoLoaded = 'true';
    }
 
    bindEditorEvents() {
      const {Autoplay} = this.Splide.Components;

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail.blockId;
        const selectedBlock = this.slideshow.querySelector(
          `[data-block-id="${blockId}"]`
        );
        if (selectedBlock) {
          const slideIndex = Number(selectedBlock.dataset.slideIndex);
          this.Splide.go(slideIndex);
        }
      });

      document.addEventListener('shopify:section:select', (event) => {
        Autoplay.pause();
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        Autoplay.play();
      });
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
}

/******/ })()
;